import LineCapsule from "./LineCapsule";
import IconCheck from "ui/icons/IconCheck";
import IconWarning from "ui/icons/status/IconWarning";
import IconInfo from "ui/icons/status/IconInfo";

## Basic Usage

<LineCapsule label="Default Label" />

---

## With Icons

<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
  <LineCapsule label="Completed" icon={<IconCheck size={14} />} />
  <LineCapsule label="Warning" icon={<IconWarning size={14} />} />
  <LineCapsule label="Information" icon={<IconInfo size={14} />} />
</div>

---

## Multiple Labels

<div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
  <LineCapsule label="Tag 1" />
  <LineCapsule label="Tag 2" />
  <LineCapsule label="Tag 3" />
  <LineCapsule label="Tag 4" />
</div>

---

## Status Indicators

<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <span style={{ width: "80px" }}>Status:</span>
    <LineCapsule label="Active" icon={<IconCheck size={12} color="emerald" />} />
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <span style={{ width: "80px" }}>Priority:</span>
    <LineCapsule label="High" icon={<IconWarning size={12} color="ruby" />} />
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <span style={{ width: "80px" }}>Type:</span>
    <LineCapsule label="Feature" icon={<IconInfo size={12} color="sapphire" />} />
  </div>
</div>

---

## In a Card Context

<div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", padding: "1rem", maxWidth: "300px" }}>
  <h4 style={{ margin: "0 0 0.5rem 0" }}>Project Alpha</h4>
  <p style={{ margin: "0 0 0.75rem 0", color: "#666", fontSize: "14px" }}>A sample project description.</p>
  <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
    <LineCapsule label="React" />
    <LineCapsule label="TypeScript" />
    <LineCapsule label="Node.js" />
  </div>
</div>


